import { FC, PropsWithChildren, ReactNode } from 'react';
import {
  SectionActions,
  SectionHeader,
  SectionSubtitle,
  SectionTitle,
  TitleGroup
} from './PageSectionHeader.styles';

interface Props {
  /** Optional second line, for context the title alone cannot carry. */
  subtitle?: ReactNode;
  /** Page-level actions, aligned to the end of the bar. */
  actions?: ReactNode;
}

/**
 * Standard page header: title on the left, actions on the right.
 *
 * Every page carries one, so the app always answers "where am I" in the same
 * place. `children` is the title, which keeps the existing call sites working;
 * a page that needs to put controls in the bar passes `actions` rather than
 * composing its own layout inside the title.
 */
const PageSectionHeader: FC<PropsWithChildren<Props>> = ({ children, subtitle, actions }) => (
  <SectionHeader className="app-shell-header">
    <TitleGroup>
      <SectionTitle>{children}</SectionTitle>
      {subtitle ? <SectionSubtitle>{subtitle}</SectionSubtitle> : null}
    </TitleGroup>
    {actions ? <SectionActions>{actions}</SectionActions> : null}
  </SectionHeader>
);

export default PageSectionHeader;
